import { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import css from './index.module.css';

import SEO from "@components/seo";
import MainContent from "@components/content";
import Tabs from "@components/tabs";

export default function Documents() {
    const [documents, setDocuments] = useState<any>([]);
    const [page, setPage] = useState(0);

    useEffect(() => {
        axios.get(`${import.meta.env.VITE_API_URL}/documents`, {
            headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('authToken')
            }
        })
        .then(response  => {
            setDocuments(response.data);
        })
        .catch(error => {
            setDocuments([]);
        });
    }, []);

    const downloadFile = async (type: number, id: string) => {
      try {
        const response = await axios.get(`${import.meta.env.VITE_API_URL}/documents/${type === 0 ? 'getInvoice' : 'getClosing'}/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('authToken'),
            },
            responseType: 'blob'
        });
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.download = `${type === 0 ? 'invoice' : 'act'}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.log(error);
      }
    };

    return (
        <MainContent>    
            <SEO 
                title="Документы"
                description=""
                ogUrl="https://artcons.io/"
            />

            <div className={css.head}>
                <h1>Документы</h1>
            </div>

            <div style={{ margin: '20px 0'}}>
                <Tabs 
                    sections={[
                        {
                            id: 0,
                            name: 'Все документы'
                        },
                        {
                            id: 1,
                            name: 'Счета'
                        },
                        {
                            id: 2,
                            name: 'Акты'
                        }
                    ]}

                    active={page}
                    setActive={setPage}
                />
            </div>

            <div className={css.table}>
                <div className={css.tableHeader}>
                    <a>Имя документа</a>
                    <a>Дата добавления</a>
                    <a>Партнёр</a>
                </div>

                <div className={css.tableBody}>
                    {documents
                        .filter((item: any) => page === 0 || (page === 1 && item.type === 0) || (page === 2 && item.type === 1))
                        .map((item: any) => (
                            <div className={css.tableDiv} key={item.id}>
                                <a>{item.type == 0 && (item.status == 0 ? <i className={`${css.wait} fi fi-rr-clock`}></i> : <i className={`${css.payed} fi fi-rr-check-circle`}></i>)} {item.type === 0 ? `Счёт от ${new Date(item.createdAt).toLocaleDateString('ru-RU')}` : `Акт от ${new Date(item.createdAt).toLocaleDateString('ru-RU')}`}</a>
                                <a>{new Date(item.createdAt).toLocaleDateString('ru-RU')} в {new Date(item.createdAt).toLocaleTimeString('ru-RU')}</a>
                                <div className={css.download}>ИП Артиков Тимур Дилшодович <a onClick={() => downloadFile(item.type, item.id)}>Скачать PDF</a></div>
                            </div>
                        ))}
                </div>
            </div>
        </MainContent>
    )
}